var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup47(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.d{fill:none;}.a{stroke:#233155;stroke-width:2px;}.b{fill:#233155;}.c{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-54 -148)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(56 148)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 20,
    height: 24,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 1,
    y: 1,
    width: 18,
    height: 22,
    rx: 1
  })), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 4,
    height: 2,
    transform: "translate(54 165)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 4,
    height: 2,
    transform: "translate(54 159)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 4,
    height: 2,
    transform: "translate(54 153)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(63 154)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 3,
    cy: 3,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 3,
    cy: 3,
    r: 2
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-5989,5h-2a5.006,5.006,0,0,1,5-5,5,5,0,0,1,5,5l-2,0a2.98,2.98,0,0,0-.88-2.12A2.978,2.978,0,0,0-5986,2a3,3,0,0,0-3,3Z",
    transform: "translate(6052 161)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup47);
export default __webpack_public_path__ + "static/media/Group 47.496ecca1206ee2ec6516fbd602432ebb.svg";
export { ForwardRef as ReactComponent };